import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { CreateDataFeedSharedService } from '../../create-data-feed-shared.service';

@Component({
    selector: 'cv-primary-key-renderer',
    templateUrl: './primary-key-renderer.component.html',
    styleUrls: ['./primary-key-renderer.component.scss']
})
export class PrimaryKeyRendererComponent implements ICellRendererAngularComp {
    params: ICellRendererParams;
    primaryKeyId: string;
    disablePrimaryKey = false;
    invalidData = false;
    isPreview: boolean;

    constructor(
        private createDataFeedSharedService: CreateDataFeedSharedService
    ) { }

    refresh() {
        return false;
    }

    agInit(params: ICellRendererParams) {
        this.params = params;
        this.primaryKeyId = 'primarykey-id' + params.rowIndex;
        this.validateFieldName();
        this.enableDisablePrimaryKey(params);
        this.isPreview = this.params.context.componentParent.isPreview;
    }

    validGridRow() {
        let validInput = true;
        if (this.params.node.data === null || this.params.node.data === undefined) {
            validInput = false;
        }
        return validInput;
    }

    onPrimaryKeyChange(event) {
        this.createDataFeedSharedService.publishPrimaryKeyChanged(this.params);
        this.params.context.componentParent.primaryKeyNotSelected = false;
        if (this.params.context.componentParent.disableSaveBtn) {
            this.params.context.componentParent.disableSaveBtn = false;
        }
    }

    ngOnInit(): void {
        this.createDataFeedSharedService.activeChanged$.subscribe((rowParams) => {
            this.enableDisablePrimaryKey(rowParams);
        });

    }

    public enableDisablePrimaryKey(rowParams) {
        if (rowParams.rowIndex === this.params.rowIndex) {
            if (!rowParams.node.data.isActive) {
                this.params.node.data.isPrimaryKey = false;
                this.disablePrimaryKey = true;
            } else {
                this.disablePrimaryKey = false;
            }
        }
    }

    validateFieldName() {
        const containsSpecialCharacter = this.params.context.componentParent.checkForSpecialCharacters(this.params.data?.fieldName);
        const containsOnlyNumbers = this.params.context.componentParent.checkForNumericCharacters(this.params.data?.fieldName);
        if (containsSpecialCharacter || containsOnlyNumbers) {
            this.invalidData = true;
            this.params.context.componentParent.invalidFieldNameFormat = true;
        } else {
            this.invalidData = false;
        }
    }

}
